import {Routes} from '@angular/router';
import {AUTH_ROUTES} from '@shared/consts/auth-routes';
import {canAuthGuard} from '@shared/guards/can-auth-guard';
import {TEAMS_ROUTES} from './teams/teams.routes';
import {EEndpointApp} from '@shared/enums/endpoint-app.enum';
import {QR_CODES_ROUTE} from './qrcode/qr-codes.routes';
import {ACCOUNT_ROUTE} from './account/account.routes';
import {CUSTOM_DOMAIN_ROUTE} from './custom-domain/custom-domain.routes';

export const routes: Routes = [
  {
    path: '',
    children: [
      AUTH_ROUTES,
      {
        path: '',
        canActivate: [canAuthGuard],
        loadComponent: () =>
          import('@shared/components/layout/layout-vertical-sidenav/layout-vertical-sidenav').then((m) => m.LayoutVerticalSidenav),
        children: [
          QR_CODES_ROUTE,
          ACCOUNT_ROUTE,
          CUSTOM_DOMAIN_ROUTE,
          {
            path: EEndpointApp.ContactUs,
            title: 'contact_us',
            loadComponent: () => import('./contact-us/contact-us.component').then((m) => m.ContactUsComponent),
          },
          {
            path: EEndpointApp.FeaturesPricing,
            title: 'contact_us',
            loadComponent: () => import('./features-and-pricing/features-and-pricing.component').then((m) => m.FeaturesAndPricingComponent),
          },
          TEAMS_ROUTES,
          {
            path: '',
            redirectTo: EEndpointApp.QRCODE_OVERVIEW,
            pathMatch: 'full',
          },
        ],
      },
      {
        path: '**',
        loadComponent: () => import('@shared/pages/error-404/error-404').then((m) => m.Error404),
      },
    ],
  },
];
